module.exports = __webpack_public_path__ + "static/media/floral-bells-border-with-vines-and-leaves-svgrepo-com.379f9091.svg";